export default "data:text/javascript;base64,aW1wb3J0IE1hcEJhaWR1IGZyb20gJy4vTWFwQmFpZHUudnVlJzsNCmV4cG9ydCBkZWZhdWx0IE1hcEJhaWR1Ow0K"